import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import React from 'react';
import Button from 'Components/UI/Button';
import Image from 'Components/ComponentLibrary/Atoms/Image';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    width: 40,
    flexShrink: 0,
    padding: theme.spacing(1),
  },
}));

export default function ActionGroup({
  actions,
  onActionClick,
}) {
  const classes = useStyles();

  return actions.map(action => (
    <Button
      variant={action.image ? 'icon' : 'text'}
      key={action.id}
      onClick={(ev) => {
        ev.stopPropagation();
        if (onActionClick) onActionClick({ action });
      }}
      className={classes.button}
      test={'action-group'}
    >
      {action.image ? <Image src={action.image} alt={action.label} /> : action.label}
    </Button>
  ));
}
ActionGroup.propTypes = {
  actions: PropTypes.array,
  onActionClick: PropTypes.func,
};
ActionGroup.defaultProps = {
  actions: [],
  onActionClick: noop,
};
